import { Injectable } from '@angular/core';
import { first } from 'lodash';

import { LocalStorageDataEnum } from '@shared/enums/local-storage-data.enum';
import { getRandomValue } from '@shared/functions/get-random-value.function';
import { AvatarThemeItem } from '@ui-components/components/avatar/config/iterfaces/avatar-theme-item';

@Injectable()
export class AvatarService {
  configList: AvatarThemeItem[] = [];
  private readonly themePrefix = 'theme-';
  private readonly themeAmount = 16;

  constructor() {
    this.setThemeConfigList();
  }

  getUserConfig(userId: number): string {
    if (!userId) {
      return 'default';
    }

    let avatarThemeItem = first(this.configList.filter(item => item.userId === userId));
    const themeNumber = +avatarThemeItem?.themeNumber;

    if (!avatarThemeItem || isNaN(themeNumber) || themeNumber > this.themeAmount || themeNumber < 0) {
      avatarThemeItem = {
        userId,
        themeNumber: this.getAvatarTheme(),
      };

      this.updateAvatarTheme(avatarThemeItem);
    }

    return `${this.themePrefix}${avatarThemeItem.themeNumber}`;
  }

  private updateAvatarTheme(avatarThemeItem: AvatarThemeItem) {
    this.configList = this.configList.filter(c => c.userId != avatarThemeItem.userId);
    this.configList.push(avatarThemeItem);
    localStorage.setItem(LocalStorageDataEnum.AVATAR_USER_CONFIG_LIST, JSON.stringify(this.configList));
  }

  private setThemeConfigList() {
    this.configList =
      (JSON.parse(localStorage.getItem(LocalStorageDataEnum.AVATAR_USER_CONFIG_LIST)) as AvatarThemeItem[]) || [];
  }

  private getAvatarTheme(): number {
    return getRandomValue(1, this.themeAmount);
  }
}
